import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'swodoc-node-information',
  templateUrl: 'swodoc-node-information.html',
  styleUrls: ['swodoc-node-information.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeInformation {
  @Input() node: any;
}
